import { yupResolver } from '@hookform/resolvers/yup';
import { ExchangeRateName } from '@okletsplay/core';
import { ExchangeRateDto, UserBalanceDto } from 'app/interfaces/dto';
import { useForm, UseFormReturn } from 'react-hook-form';
import { DEFAULT_PAIR } from '../constants';
import { buildAutoSwapFormSchema } from './auto-swap-form-schema';

export interface AutoSwapFormFields {
  threshold: number;
  purchase: number;
  enabled: boolean;
  pair: ExchangeRateName;
}

interface UseAutoSwapFormHook {
  form: UseFormReturn<AutoSwapFormFields>;
}

export const useAutoSwapForm = (
  getUserAccounts: () => (UserBalanceDto | undefined)[],
  getExchangeRates: () => (ExchangeRateDto | undefined)[]
): UseAutoSwapFormHook => {
  const formResolver = yupResolver(buildAutoSwapFormSchema(getUserAccounts, getExchangeRates));

  const form = useForm<AutoSwapFormFields>({
    mode: 'onChange',
    resolver: formResolver,
    defaultValues: {
      pair: DEFAULT_PAIR,
      enabled: false,
      threshold: 0,
      purchase: 0,
    },
  });

  return { form };
};
